import { ILocalStorageKey } from '@/types/ILocalStorageKey';
import { getLocalStorageKey } from '@/utils/getLocalStorageKey';

export const cleanLocalStorageKey = (keyName: ILocalStorageKey): void => {
  const fullKey = getLocalStorageKey(keyName);
  try {
    localStorage.removeItem(fullKey);
    // eslint-disable-next-line
  } catch (e) {
    // do nothing
  }
};
